// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_aTa","cls2":"AuthorsCard-cls2_isk AuthorsCard-cls1_aTa","altLook":"AuthorsCard-altLook_iJ2"};